import { useCheckPatientPhoneExists, useSendPatientInvitation } from '@MP/shared/api/hooks/patient';

import type { PatientInvitationRepository } from '../stores/PatientInvitationViewModel';

/** 환자 초대 ViewModel이 소비할 데이터 접근 계층을 조립한다(배선 전용, 비즈니스 로직 없음). */
const usePatientInvitationRepository = (): PatientInvitationRepository => {
  const { mutateAsync: checkPhoneExists } = useCheckPatientPhoneExists();
  const { mutateAsync: sendInvitation } = useSendPatientInvitation();

  return { checkPhoneExists, sendInvitation };
};

export default usePatientInvitationRepository;
